import type { PostgrestError } from '@supabase/supabase-js';

/**
 * Every row of a read, page by page: PostgREST returns at most its row limit per request, so a long read would
 * otherwise lose rows silently (D12). The read must order on unique keys.
 */
export async function readAllPages<Row>(
  page: (from: number, to: number) => PromiseLike<{ data: Row[] | null; error: PostgrestError | null }>,
  pageSize = 1000,
): Promise<{ data: Row[]; error: PostgrestError | null }> {
  const rows: Row[] = [];
  for (let from = 0; ; from += pageSize) {
    const { data, error } = await page(from, from + pageSize - 1);
    if (error) return { data: rows, error };
    rows.push(...(data ?? []));
    if (!data || data.length < pageSize) return { data: rows, error: null };
  }
}
